import _ from 'lodash';
import store from '../store';

export default {
  open(pageName: string) {
    const terminalSize = _.get(store.getState().app.userData, 'terminal.viewport', {});
    window.open(
      `/terminal/${pageName}`,
      '_blank',
      `toolbar=no,scrollbars=no,resizable=yes,width=${terminalSize.width || 780},height=${terminalSize.height || 480}`
    );
  },
};
